import { render, staticRenderFns } from "./CreateVaultForm.vue?vue&type=template&id=4659fc2e&scoped=true&"
import script from "./CreateVaultForm.vue?vue&type=script&lang=js&"
export * from "./CreateVaultForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4659fc2e",
  null
  
)

export default component.exports